/* eslint-disable @typescript-eslint/no-unused-expressions */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { findIndex } from 'lodash';

const initialState = {
  list_faq: {
    faqs: [],
  } as any,
  select_faq: {} as any,
  page: 1,
};

const faqSlice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    requestFAQs: (_state, _action: PayloadAction<{ page?: number; limit?: number }>) => {},
    saveFAQs: (state, action: PayloadAction<{ data: any }>) => {
      const { data } = action.payload;
      state.list_faq = data;
    },
    clearFAQInList: (state, { payload: { id } }: PayloadAction<{ id: string }>) => {
      const index = findIndex(state.list_faq.faqs, { id });
      state.list_faq.faqs.splice(index, 1);
    },
    selectFAQ: (state, action: PayloadAction<{ data: any }>) => {
      state.select_faq = action.payload.data;
    },
    resetFAQs: (state, _action: PayloadAction) => {
      return Object.assign(state, initialState);
    },
    deleteFAQs: (_state, _action: PayloadAction<{ data: any }>) => undefined,
  },
});

export default faqSlice;
